import { ShortContentCompletedVideoView } from '../components/ShortContentCompletedVideoView';
import { useShortFromPropsOrParams } from '../shortContentHooks';
import { VideoPlayerWithControls } from '../../video';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentVideo = ({
  additionalTracking,
  contentPlaylistId,
  displayInteractiveEducation,
  enableAdaptToIndustry = false,
  handleDisplayInteractiveEducation,
  interactiveEducationEnabled,
  shortId
}) => {
  const {
    short,
    playlistId
  } = useShortFromPropsOrParams({
    shortId,
    playlistId: contentPlaylistId
  });
  const {
    name,
    contentId
  } = short || {};
  if (!short) {
    return null;
  }
  return /*#__PURE__*/_jsx(VideoPlayerWithControls, {
    additionalTracking: additionalTracking,
    completedVideoView: /*#__PURE__*/_jsx(ShortContentCompletedVideoView, {}),
    displayInteractiveEducation: displayInteractiveEducation,
    enableAdaptToIndustry: enableAdaptToIndustry,
    enableQuizMe: true,
    enableSummarize: true,
    handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
    interactiveEducationEnabled: interactiveEducationEnabled,
    isPubliclyVisible: true // TODO: Update this to read short visibility when available
    ,
    playlistId: playlistId,
    shortId: contentId,
    shortName: name
  });
};
export default ShortContentVideo;